import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  LogFilter,
  ErrorLogResponse,
  ErrorLogDetailResponse,
  ServiceApiLogResponse,
  ServiceApiLogDetailResponse,
} from "../types/logs.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.logs;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

const toQuery = (filter: LogFilter) => {
  const params = new URLSearchParams();
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  return params.toString();
};

export const logsService = {
  async errors(filter: LogFilter): Promise<ErrorLogResponse> {
    try {
      return await apiClient<ErrorLogResponse>(endpoints.errors(toQuery(filter)), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load error logs.") as unknown as ErrorLogResponse;
    }
  },

  async errorDetails(id: number | string): Promise<ErrorLogDetailResponse> {
    try {
      return await apiClient<ErrorLogDetailResponse>(endpoints.errorDetails(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load error log details.") as unknown as ErrorLogDetailResponse;
    }
  },

  async serviceApi(filter: LogFilter): Promise<ServiceApiLogResponse> {
    try {
      return await apiClient<ServiceApiLogResponse>(endpoints.serviceApi(toQuery(filter)), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load service API logs.") as unknown as ServiceApiLogResponse;
    }
  },

  async serviceApiDetails(id: number | string): Promise<ServiceApiLogDetailResponse> {
    try {
      return await apiClient<ServiceApiLogDetailResponse>(endpoints.serviceApiDetails(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load service API log details.") as unknown as ServiceApiLogDetailResponse;
    }
  },
};
